import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useAuth } from "./index.js";
export function LoginButton({ auth, sx = [], ...props }) {
    const { t } = useTranslation("LoginButton");
    const { signinRedirect, isLoading, isInitiated } = auth || useAuth();
    return (_jsx(LoadingButton, { variant: "contained", loading: !isInitiated || isLoading, onClick: () => signinRedirect(), sx: [{ whiteSpace: "nowrap" }, ...(Array.isArray(sx) ? sx : [sx])], "data-testid": "login-button", ...props, children: t("login") }));
}
//# sourceMappingURL=LoginButton.js.map